var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg33(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96507)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9972 4.78711C12.4114 4.78711 12.7472 5.1229 12.7472 5.53711V5.98592C17.993 6.36031 22.203 10.629 22.4844 15.8989H23.2966C23.7108 15.8989 24.0466 16.2347 24.0466 16.6489C24.0466 17.0632 23.7108 17.3989 23.2966 17.3989H22.8494L22.5819 18.1C22.0894 19.3911 20.8976 20.2121 19.5157 20.2121H4.47786C3.09526 20.2121 1.90293 19.3903 1.41089 18.0981C1.41089 18.0981 1.41089 18.0981 1.41089 18.0981L1.14466 17.3989H0.703125C0.288911 17.3989 -0.046875 17.0632 -0.046875 16.6489C-0.046875 16.2347 0.288911 15.8989 0.703125 15.8989H1.50993C1.79131 10.6289 6.0014 6.36025 11.2472 5.98592V5.53711C11.2472 5.1229 11.583 4.78711 11.9972 4.78711ZM2.74973 17.3989L2.8127 17.5643L2.8127 17.5643C3.08321 18.2748 3.71772 18.7121 4.47786 18.7121H19.5157C20.2754 18.7121 20.9097 18.2752 21.1804 17.5654L21.1805 17.5654L21.2439 17.3989H2.74973ZM20.9818 15.8989H3.01248C3.30554 11.2085 7.2365 7.45924 11.9971 7.45924C16.7578 7.45924 20.6888 11.2085 20.9818 15.8989Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.2423681440ca82fc261f72ee470c67f3.svg";
export { ForwardRef as ReactComponent };